import { useState } from 'react';
import { supabase } from '../lib/supabase';

export function useResponsibleAgencies() {
  const [agencies, setAgencies] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const loadUserAgencies = async (userId: string) => {
    setLoading(true);
    setError('');
    try {
      console.log('Loading responsible agencies for userId:', userId);
      
      const { data, error } = await supabase
        .from('responsable_agencies')
        .select('agency')
        .eq('user_id', userId);

      console.log('Supabase response:', { data, error });

      if (error) throw error;
      
      const agencyNames = (data || []).map(row => row.agency);
      console.log('Extracted agency names:', agencyNames);
      
      setAgencies(agencyNames);
    } catch (err: any) {
      console.error('Error loading responsible agencies:', err);
      setError(err.message);
      setAgencies([]);
    } finally {
      setLoading(false);
    }
  };

  return { agencies, loading, error, loadUserAgencies };
}